import { DataActiveStatusEnum } from "../Category/types";

export interface IData {
  _id: string;
  title: string;
  categoryTitle: string;
  categoryId: string;
  type: TypeEnum;
  status: DataActiveStatusEnum;
  createdAt: string;
  updatedAt: string;
  featuredImage: string;
  sortOrder: number;
}
export enum TypeEnum {
  Null = "null",
  Individual = "Individual",
  Package = "Package",
}

export interface SubCategoryState {
  formData: IData;
  list: IData[];
  allList: IData[];
  allGroupList: IData[];
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  toggleLoading: boolean;
}

export type InitialState = SubCategoryState;
